export default __webpack_public_path__ + "static/media/Banner_TAP.c062d2cc.png";